import { UpdateDrawRequestsAction, UPDATE_DRAW_REQUESTS_ACTION } from "../actions/drawRequestActions"
import { Reducer } from "redux"
import { keyBy } from "lodash-es"
import { DrawRequest } from "@all-good-apps/draft-chess-common"

export interface DrawRequestByIdReducerState {
  byId: {
    [offerDrawId: string]: DrawRequest
  }
}

const initialState: DrawRequestByIdReducerState = {
  byId: {},
}

const drawRequestsByIdReducer: Reducer<DrawRequestByIdReducerState, UpdateDrawRequestsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case UPDATE_DRAW_REQUESTS_ACTION:
      const { drawRequests } = action.payload

      const newById = {
        ...state.byId,
        ...keyBy(drawRequests, "requestId"),
      }

      return {
        ...state,
        byId: newById,
      }
    default:
      return state
  }
}

export default drawRequestsByIdReducer
